<!--登录-->
<template>
	<div class="page-body center-wrap">
		<div class="form-div">
			<div class="title txt-24 txt-w7">{{$t('重置密码')}}</div>
			<div class="title2 txt-16 txt-w4">{{$t('为了您的资产安全，修改密码后24小时内禁止交易。')}}</div>
			<div class="tabs dis-fle txt-16">
				<span class="item" :class="form.type == 1 ? 'active': ''" @click="changeTabs(1)">{{$t('登录密码')}}</span>
				<span class="item" :class="form.type == 2 ? 'active': ''" @click="changeTabs(2)">{{$t('资金密码')}}</span>
			</div>
			
			<div class="form-item">
				<label class="label txt-20">{{$t('密码')}}</label>
				<div class="value">
					<el-input v-model="form.password" :placeholder="$t('请输入密码')" size="medium" type="password" clearable
						show-password></el-input>
				</div>
			</div>
			<div class="form-item">
				<label class="label txt-20">{{$t('确认密码')}}</label>
				<div class="value">
					<el-input v-model="form.passwordS" :placeholder="$t('请再次输入密码')" size="medium" type="password"
						clearable show-password></el-input>
				</div>
			</div>

			<div class="but" @click="resetPwd">{{$t('提交')}}</div>

			<router-link to="/pc/login" class="qt txt-14 cur-poi">
				<span>{{$t('登录')}}</span>
			</router-link>
		</div>
	</div>
</template>
<script>
	import {
		post
	} from '@/http/request'

	class FormData {
		constructor() {
			this.account = "";
			this.password = "";
			this.passwordS = "";
			this.code = "000000";
			this.type = "1";
		}
	}
	export default {
		components: {},
		data() {
			return {
				form: new FormData()
			};
		},
		mounted() {

		},
		beforeUnmount() {},
		methods: {
			changeTabs(val) {
				if (val == this.form.type) return
				this.form = new FormData()
				this.form.type = val
			},
			resetPwd() {
				if (this.form.passwordS != this.form.password) {
					this.$notify.error(this.$t('两次密码不一致'));
					return
				}
				post(this.$apis.resetPwd, this.form).then(res => {
					if (res.code != 1) return
					this.$notify.success(res.msg)
					setTimeout(() => {
						this.$nav.back()
					}, 800)
				})
			}
		},
	};
</script>
<style lang="scss" scoped>
	@import "~@/style/pc/login.scss";

	.txt {
		display: inline-block;
		color: var(--color-txt1);
		line-height: 42px;
		padding-right: 10px;
	}
</style>